import React, { useState } from "react";

import "./header.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Navbar, Container } from "react-bootstrap";
import { HeaderCombined, Purebrand } from "assets/images";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Check from "Pages/landing/Check";
import MobileMenu from "components/MobileMenu/MobileMenu";
import moment from "moment";

const Headerss = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const currentYear = moment().format("YYYY");
  return (
    <React.Fragment>
      {location.pathname === "/meeting-status-check" ? null : (
        <header>
          <Navbar bg="transparent">
            <Container style={{maxWidth: "1650px", paddingLeft:"40px", paddingRight:"40px"}}>
              <Navbar.Brand className="pb-logo-header">
                {location.pathname === "/signup" ||
                location.pathname === "/login" ||
                location.pathname === "/forgot-password" ||
                location.pathname === "/request-account-deletion" ||
                location.pathname === "/account-deletion" ||
                location.pathname.split("/")[1] === "reset-password" ||
                location.pathname === "/privacy-policy" ||
                location.pathname === "/terms-and-conditions" ||
                location.pathname === "/support" ||
                location.pathname.split("/")[1] === "verify-account" ? (
                  <>
                    <p>
                      <img
                        src={Purebrand}
                        className="Header-img murphy_door"
                        style={{ width: "300px" }}
                        alt="murphydoor"
                        onClick={() => navigate("/")}
                      />
                    </p>
                  </>
                ) : (
                  <img
                    src={Purebrand}
                    className="Header-img"
                    style={{ width: "300px" }}
                    alt="logo"
                    onClick={() => navigate("/")}
                  />
                )}{" "}
              </Navbar.Brand>

              {/* Show nav links only on homepage and business pages */}
              {/* {(location.pathname === "/" || location.pathname === "/business") && (
                <div className="nav-links">
                  <span
                    className={`nav-link ${location.pathname === "/" ? "active" : ""}`}
                    onClick={() => navigate("/")}
                  >
                    For Hosts
                  </span>
                  <span
                    className={`nav-link ${location.pathname === "/business" ? "active" : ""}`}
                    onClick={() => navigate("/business")}
                  >
                    For Businesses
                  </span>
                </div>
              )} */}

              {/* Show consistent Sign up/Log in buttons on all public pages */}
              <Check signupUrl={location.pathname}/>

              {/* Hamburger Menu Button for Mobile */}
              <button
                className={`hamburger-menu ${mobileMenuOpen ? 'active' : ''}`}
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                aria-label="Toggle mobile menu"
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
            </Container>
          </Navbar>

          {/* Mobile Menu Component */}
          <MobileMenu
            isOpen={mobileMenuOpen}
            onClose={() => setMobileMenuOpen(false)}
          />
        </header>
      )}

      <Outlet />
      {/* {props.children} */}

      <footer id='footer' className='footer'>
        <Container className='footer-container'>
          <div className='footer-left'>
            <img
              src={Purebrand}
              className='footer-logo'
              alt='Purebrand Logo'
              onClick={() => navigate("/")}
            />
            <p>© {currentYear} purebrand™, Inc. All rights reserved.</p>
          </div>

          <div className='footer-links'>
            <span onClick={() => navigate("/privacy-policy")}>
              Privacy Policy
            </span>
            <span onClick={() => navigate(`/terms-and-conditions${location.pathname === "/business"? "?business=true":""}`)}>
              Terms & Conditions
            </span>
            <span onClick={() => navigate("/support")}>Support</span>
          </div>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Headerss;
